import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, TwoFactorTitle } from "../../../../../Constants/Constants";
import EmailVerification from "./EmailVerification/EmailVerification";
import TwoFactorAuthentication from "./TwoFactorAuthentication/TwoFactorAuthentication";

const TwoFactorContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TwoFactorTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TwoFactorAuthentication />
          <EmailVerification />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TwoFactorContainer;
